import Chat from "./Chat";

export default function Strategist(props) {
  const fa = props.lang === "fa";
  const t = { ...props.t, advisor: fa ? "اتاق استراتژیست نورین" : "NOORIN Strategist Room", empty: fa ? "گفت‌وگوی مشاورهٔ شما برای همین کسب‌وکار اینجا ادامه پیدا می‌کند. شما وارد شده‌اید و لازم نیست دوباره وارد شوید. اطلاعات و تصمیم‌های ثبت‌شده را در نظر می‌گیریم؛ برای تصمیم‌های حساس، تأیید شما لازم است." : "Your advisory conversation continues here for this business. You are already signed in, so you do not need to log in again. Recorded information and decisions inform the discussion; sensitive decisions always need your confirmation." };
  return <Chat {...props} t={t} />;
}
